import { NOTIFICATION_TYPES, useNotificationStore } from '@ui/app-notification/stores/useNotificationStore'
import { useI18n } from 'vue-i18n'

import { resolveErrorMessage } from '@supplier/utils/errors'
import { LOADING_TOAST_MS, TOAST_MS } from '@supplier/consts'

export function useSupplierNotify() {
  const notificationStore = useNotificationStore()
  const { t } = useI18n()

  function push(type, text, options = {}) {
    const notification = { type, text, time: TOAST_MS, ...options }
    notificationStore.pushNotification(notification)
    return notification.id
  }

  return {
    success: (text, options) => push(NOTIFICATION_TYPES.SUCCESS, text, options),
    info: (text, options) => push(NOTIFICATION_TYPES.INFO, text, options),
    error: (errorOrText, options) => push(
      NOTIFICATION_TYPES.ERROR,
      resolveErrorMessage(errorOrText, t('ui.supplier_portal.common.generic_error')),
      options,
    ),
    loading: (text, options) => push(NOTIFICATION_TYPES.LOADING, text, { time: LOADING_TOAST_MS, ...options }),
    dismiss: (id) => notificationStore.removeItem(id),
  }
}
